const successSound = new Audio('assets/audio/correct.mp3');
const errorSound = new Audio('assets/audio/incorrect.mp3');

export function audioCorrect() {
    successSound.currentTime = 0;
    successSound.play();
}

export function audioIncorrect() {
    errorSound.currentTime = 0;
    errorSound.play().catch(error => {
        console.log('Failed to play audio:', error);
    });
}